import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {ProjectData} from '../../common/model/project-data';
import {Localization} from '../../../../projects/common/src/lib/interface/localization.extension';
import {StringsService} from '../../../../projects/common/src/lib/services/strings.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';


@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'app-join-projects-popup',
  templateUrl: 'join-projects.popup.html',
  styleUrls: ['../../styles/common.scss']
})
export class JoinProjectsPopup extends Localization {
  projects = inject(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<JoinProjectsPopup>>(MatDialogRef);


  newProjectName = '';

  constructor() {

    super();
    const projects = this.projects;
    const dialogRef = this.dialogRef;


    dialogRef.disableClose = false;

    this.newProjectName = this.getString('untitled_project');
    if (!projects) {
      this.dialogRef.close(null);
      return;
    }
  }

  /** A blank name closed the dialog and the join was dropped without a word. */
  hasName(): boolean {
    return !!this.newProjectName?.trim();
  }

  save() {
    if (!this.hasName()) {
      return;
    }
    this.dialogRef.close(this.newProjectName.trim());
  }

  cancel() {
    this.dialogRef.close(null);
  }
}
